define('studio/studio-overlay',["require", "exports", "../tracks/start-slices", "../tracks/track-enabled", "../tracks/track-state", "../util/convert"], function (require, exports, start_slices_1, trackEnabled, trackState, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var overlay;
    var summaryText = "";
    var focused = false;
    function init() {
        overlay = document.getElementById("studio-overlay");
        // Subscribe to focus updates
        trackState.focusUpdates.subscribe(onFocus);
        trackEnabled.trackEnabled.subscribe(updateSummary);
        trackEnabled.trackDisabled.subscribe(updateSummary);
    }
    exports.init = init;
    function onFocus(point, track) {
        if (point && track) {
            focused = true;
            overlay.style.display = "block";
            overlay.innerText = ("\n      " + track.niceString() + "\n      " + dateString(point) + "\n      " + timeString(point, track) + "\n      " + altString(point) + "\n      h-dist: " + convert_1.default.distance.localString(point.x / convert_1.default.distance.units) + "\n      v-dist: " + convert_1.default.distance.localString(point.y / convert_1.default.distance.units) + "\n      h-speed: " + convert_1.default.speed.localString(point.groundspeed) + "\n      v-speed: " + convert_1.default.speed.localString(-point.climb) + "\n      glide: " + convert_1.default.glide.localString(point.glideRatio, 1) + "\n    ").trim();
        }
        else {
            focused = false;
            overlay.innerHTML = summaryText;
            if (!summaryText) {
                overlay.style.display = "none";
            }
        }
    }
    function updateSummary() {
        (0, start_slices_1.startSlices)().then(function (str) {
            summaryText = "<strong>Start summary</strong>\n" + str;
            if (!focused) {
                overlay.innerHTML = summaryText;
            }
            overlay.style.display = "block";
        }).catch(function () {
            summaryText = "";
            overlay.style.display = "none";
        });
    }
    function altString(point) {
        if (point.alt === undefined) {
            return "alt: ";
        }
        else {
            return "alt: " + convert_1.default.distance.localString(point.alt) + " MSL";
        }
    }
    function dateString(point) {
        if (!point.date) {
            return "";
        }
        else if (point.millis < 10000000) {
            return "";
        }
        else {
            return point.date.toLocaleString();
        }
    }
    function timeString(point, track) {
        if (!point.date) {
            return "t: ";
        }
        else if (point.millis < 10000000) {
            return "t: " + (point.millis * 0.001).toFixed(1) + " s";
        }
        else {
            return "t: " + ((point.millis - track.startTime()) * 0.001).toFixed(1) + " s";
        }
    }
});
//# sourceMappingURL=/assets/javascripts/studio/studio-overlay.js.map;
